module.exports = __webpack_public_path__ + "static/1_1_defineai_DA-522fedd605ccf0de0f78d6af47bf2cb1.svg";